export function FieldRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex items-start justify-between gap-4 py-2.5 border-b border-slate-100 last:border-0">
      <span className="text-[12px] text-slate-500 flex-shrink-0">{label}</span>
      <span className="text-[12.5px] font-semibold text-slate-900 text-right">{value}</span>
    </div>
  );
}
